// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1RuSk","content":"content__1xJP3","picture":"picture__r_PW6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/ImageTwoColumn/styles.scss
// module id = 254
// module chunks = 0